import {
  EAST_GEN_CLIENT,
  GENON,
  KINDLE_CLIENT,
  LANYARD_CLIENT,
  NRG_CLIENT,
  PJM_CLIENT,
  TALEN_CLIENT,
} from '../../client'

// import { visibleCompoValues } from './reportVisibleStatus'
export const visibleCompoValues = {
  visibleWindUtilitySelection: false,
  visibleWindSubgroupSelection: false,
  visibleErrorCodeCheckbox: false,
  visibleMAGroup: false,
  visibleEafCheckbox: false,
  visibleExcludeOmc: false,
  visiblePjmNerc: false,
  visibleGorpIRMB: false,
  visibleByRegionFuel: false,
  visibleByCategoryCauseCode: false,
  visibleYTD: false,
  visibleEventDuration: false,
  visible10StartEndMonth: false, // for NRG
  visibleGoals: false,
  visibleFinalsummary: false,
  visibleWinterSummer: false,
  visibleQuickSelction: true, // not implemented
  visibleSingleYear: false, // not implemented
  visibleMonthYear: false,
  visibleMonthYearEnd: false,
  visibleStartDateLabel: 'Start Date ',
  visibleStartDate: false,
  visibleEndDateLabel: 'End Date ',
  visibleEndDate: false,
  visibleStartHour: false,
  visibleEndHour: false,
  visibleOMC: false,
  visibleFormat: false,
  visibleRollupDetail: false,
  visibleGroupByMonthOrUnit: false,
  visibleDataSet: false,
  visibleCauseCode: false,
  visibleUnit: true,
  visibleStation: false,
  visibleStationDisabled: true,
  visibleUnitDisabled: false,
  choiceUnitStation: 'unit',
  visiblePDFButton: true,
  visibleCSVButton: true,
  visibleExcelButton: false,
  visibleBackgroundButton: true,
  horizontalvartical: 'Vartical',
  selectedStartHour: 0,
  selectedEndHour: 24,
  visible2550all: false,
  visible2550showAll: true,
  rollupdetail: '1',
  visibleMW2Exclude: false,
  visibleMonthlyCauseCodeFlag: false,
  visibleEventTypes: false,
  visibleRegionriverStationcodeSelection: false,
  hideCustomDateSelection: false,
  visibleEventHourDuration: false, // for duke-fho

  visibleStartYear: false,
  visibleEndYear: false,
  visibleSeasonBoth: false,

  visible6StartEndDate: false, // for kindle
  visible6ExceludeEvent: false, // foe kindle
  visible10ExceludeEvent: false, // foe  nrg
  visibleEffectieveDate: false, // for nrg: analytics group forecast
}

export const getCode = (code, idx) => {
  return code.length < idx + 1 ? '0' : code.substr(idx, 1)
}

export const getVisibilityStatusPrReport2 = (
  reportId,
  idDisplayCodeMap,
  reportIdNameMap,
  omcBefore,
  CLIENT,
  stateData = {}
) => {
  const displayCode = idDisplayCodeMap[reportId]

  const viewType = getViewType(getCode(displayCode, 1))
  const dateType = getDateType(getCode(displayCode, 2))

  const monthType = getMonthType(getCode(displayCode, 3))
  const endDateType = getEndDateType(getCode(displayCode, 4))
  const unitLabel = getUnitLabelDisp(getCode(displayCode, 5))
  const quickSelection = getQuickSelection(getCode(displayCode, 6))
  const radioSelection = getRadioSelection(getCode(displayCode, 7), CLIENT)
  const customePanel = getCostomPanel(
    getCode(displayCode, 8),
    reportIdNameMap[reportId],
    CLIENT,
    reportId
  )
  const groupBy = getGroupBy(getCode(displayCode, 9))
  const displayFormat = getDisplayType(getCode(displayCode, 10))
  const viewUtility = getUtilityCode(getCode(displayCode, 11))
  const viewHour = getHourDisplay(getCode(displayCode, 12))
  const pjmNerc = getPjmNerc(getCode(displayCode, 13), CLIENT)
  const omc = getOmc(getCode(displayCode, 14), omcBefore)
  const isRetiried = {} // getCode(displayCode,15)
  const viewButton = getViewButton(getCode(displayCode, 16))
  const viewUtility2 = {} // getCode(displayCode,17)
  const eafCheckbof = getEAFCheckbox(getCode(displayCode, 18))
  const maGroup = getMAgroup(getCode(displayCode, 19))
  const modDate = getModDate(getCode(displayCode, 20))
  const generateButon = getGenerateButton(getCode(displayCode, 21))
  const windsubGroups = getWindSubgroup(getCode(displayCode, 22))
  const regionRiverStationcodeSelection = getRegionRiverStationcodeSelection(
    getCode(displayCode, 23)
  ) // no mapping
  const erroCode = getErrorCode(getCode(displayCode, 24))
  const windUtility = getWindUtility(getCode(displayCode, 25))

  const { defaultNercPjm = '1' } = stateData || {}

  const final = {
    typeBy: defaultNercPjm,
    visibleCustomDateSelection: reportId !== '20',
    ...visibleCompoValues,
    ...displayCode,
    ...viewType,
    ...dateType,
    ...monthType,
    ...endDateType,
    ...unitLabel,
    ...quickSelection,
    ...radioSelection,
    ...customePanel,
    ...groupBy,
    ...displayFormat,
    ...viewUtility,
    ...viewHour,
    ...pjmNerc,
    ...omc,
    ...isRetiried,
    ...viewButton,
    ...viewUtility2,
    ...eafCheckbof,
    ...maGroup,
    ...modDate,
    ...generateButon,
    ...windsubGroups,
    ...regionRiverStationcodeSelection,
    ...erroCode,
    ...windUtility,
  }

  return final
}

const getUtilityCode = codeIdxType => {
  if (codeIdxType === '1') return { visibleUnit: false }
  return {}
}

// eslint-disable-next-line no-unused-vars
const getWindUtility = codeIdxType => {
  if (codeIdxType === '1') return { visibleWindUtilitySelection: true }
  return {}
}
const getWindSubgroup = codeIdxType => {
  if (codeIdxType === '1') return { visibleWindSubgroupSelection: true }
  else return {}
}

const getErrorCode = codeIdxType => {
  if (codeIdxType === '1') return { visibleErrorCodeCheckbox: true }
  return {}
}

const getGenerateButton = codeIdxType => {
  if (codeIdxType === '1') return { visibleBackgroundButton: false }
  return {}
}

const getModDate = codeIdxType => {
  if (codeIdxType === '1')
    return {
      visibleStartDateLabel: 'Mod. Start ',
      visibleStartDate: true,
      visibleEndDateLabel: 'Mod. End ',
      visibleEndDate: true,
      visibleDataSet: true,
    }
  return {}
}
const getMAgroup = codeIdxType => {
  if (codeIdxType === '1') return { visibleMAGroup: true }
  return {}
}

const getEAFCheckbox = codeIdxType => {
  if (codeIdxType === '1') return { visibleEafCheckbox: true }
  else if (codeIdxType === '2') return { visibleMW2Exclude: true, eafOnly: 'Y' }
  return {}
}
const getViewButton = codeIdxType => {
  if (codeIdxType === '1') return { visiblePDFButton: false }
  if (codeIdxType === '2') return { visibleCSVButton: false }
  if (codeIdxType === '3')
    return { visiblePDFButton: false, visibleCSVButton: false }
  if (codeIdxType === '4') return { visibleExcelButton: false }
  if (codeIdxType === '5')
    return {
      visiblePDFButton: false,
      visibleCSVButton: false,
      visibleExcelButton: true,
    }
  else return {}
}

const getOmc = (codeIdxType, omcBefore) => {
  if (codeIdxType === '1' || codeIdxType === '3') return { visibleOMC: true }
  else if (codeIdxType === '2') return { visibleOMC: false, omc: '1' }
  else if (codeIdxType === '4')
    return omcBefore ? { visibleOMC: true } : { visibleOMC: false }
  else if (codeIdxType === '5') return { visibleExcludeOmc: true }
  else return {}
}

const getPjmNerc = (codeIdxType, CLIENT) => {
  if (codeIdxType === '1') return { visiblePjmNerc: true }
  if (codeIdxType === '2' && CLIENT === NRG_CLIENT)
    return {
      visibleEffectieveDate: false,
      visibleMonthYear: false,
      visiblePjmNerc: true,
    }
  if (codeIdxType === '3')
    return {
      visibleEffectieveDate: false,
      visiblePjmNerc: true,
    }
  return {}
}

const getHourDisplay = codeIdxType => {
  if (codeIdxType === '1')
    return {
      visibleStartDateLabel: 'Start ',
      visibleStartDate: true,
      visibleEndDateLabel: 'End ',
      visibleEndDate: true,
      visibleStartHour: true,
      visibleEndHour: true,
    }
  else return {}
}

const getDisplayType = codeIdxType => {
  if (codeIdxType === '0' || codeIdxType === '3')
    return { visibleFormat: false }
  else if (codeIdxType === '1' || codeIdxType === '2')
    return { visibleFormat: true }
  else return {}
}

const getGroupBy = codeIdxType => {
  if (codeIdxType === '0') return {}
  if (codeIdxType === '1') return { visibleGroupByMonthOrUnit: true }
  else if (codeIdxType === '2') return { visibleEventDuration: true }
  else if (codeIdxType === '3') return { visibleYTD: true }
  else if (codeIdxType === '4') return { visibleByCategoryCauseCode: true }
  else if (codeIdxType === '5') return { visibleByRegionFuel: true }
  else if (codeIdxType === '6') return { visibleGorpIRMB: true }
  return {}
}
const getCostomPanel = (codeIdxType, reportName, CLIENT) => {
  if (codeIdxType !== '0') {
    if (
      reportName === 'CAUSE CODE' ||
      reportName === 'PLANT MATRIX REPORT' ||
      reportName === 'MA CAUSE CODE' ||
      reportName === 'MA CAUSE CODE MONTH' ||
      reportName === 'OUTAGE SPILL REPORT V.2' ||
      reportName === 'AMPLIFICATION Report'
    )
      return { visibleCauseCode: true, visibleEventTypes: true }
    else if (reportName === 'EAF REPORT')
      return { visible10StartEndMonth: true }
    else if (reportName === 'PEAK AVAILABILITY' && CLIENT === NRG_CLIENT)
      return { visible6StartEndDate: true, visible6ExceludeEvent: true }
    else if (
      reportName === 'PEAK AVAILABILITY' &&
      (CLIENT === KINDLE_CLIENT ||
        CLIENT === EAST_GEN_CLIENT ||
        CLIENT === LANYARD_CLIENT ||
        CLIENT === GENON)
    )
      return { visible6StartEndDate: true, visible6ExceludeEvent: false }
    else if (
      reportName === 'PEAK AVAILABILITY' &&
      (CLIENT === LANYARD_CLIENT || CLIENT === GENON)
    )
      return { visible6StartEndDate: true, visible6ExceludeEvent: true }
    else if (reportName === 'OPERATING REPORT' && CLIENT === NRG_CLIENT)
      return {
        visible6StartEndDate: false,
        visible10ExceludeEvent: true,
        visible6ExceludeEvent: true,
      }
  } else return {}
}

export const getRadioSelection = (codeIdxType, CLIENT) => {
  if (codeIdxType === '0') return { visibleRollupDetail: false }
  else if (codeIdxType === '1') return { visibleRollupDetail: true }
  else if (codeIdxType === '2')
    return { visibleWinterSummer: true, visibleSeasonBoth: true }
  else if (codeIdxType === '3')
    return { visible2550all: true, visible2550showAll: true }
  else if (codeIdxType === '4') return { visibleFinalsummary: true }
  else if (codeIdxType === '5') {
    if (
      CLIENT === PJM_CLIENT ||
      CLIENT === TALEN_CLIENT ||
      CLIENT === LANYARD_CLIENT ||
      CLIENT === GENON
    )
      return { visibleWinterSummer: true }
    else
      return {
        visible2550all: true,
        visible2550showAll: false,
      }
  } else if (codeIdxType === '6') return { visibleGoals: true }
  else if (codeIdxType === '7') return { visibleMonthlyCauseCodeFlag: true }
  else if (codeIdxType === '8') return { visibleEventHourDuration: true }
  else if (codeIdxType === '9') return { visibleWinterSummer: true }
  else return {}
}

export const isRadioSelectionAvaliable = radioDataObj => {
  const anyAvaliable = Object.keys(radioDataObj || {}).find(
    f => radioDataObj[f] === true
  )
  return !!anyAvaliable
}

const getQuickSelection = codeIdxType => {
  if (codeIdxType === '0') return { visibleQuickSelction: false }
  else return {}
}

// eslint-disable-next-line no-unused-vars
const getUnitLabelDisp = codeIdxType => {
  return {}
}

const getEndDateType = codeIdxType => {
  if (codeIdxType === '0')
    return {
      visibleMonthYear: true,
      visibleMonthYearEnd: false,
      visibleStartDate: false,
      visibleStartHour: false,
      visibleCustomDateSelection: false,
    }
  if (codeIdxType === '2')
    return {
      visibleMonthYear: true,
      visibleMonthYearEnd: true,
      visibleStartDate: false,
      visibleStartHour: false,
      visibleCustomDateSelection: true,
    }
  if (codeIdxType === '3')
    return {
      visibleCustomDateSelection: false,
      visibleStartYear: true,
      visibleStartDateLabel: 'Year ',
      // visibleSingleYear: true,
      visibleMonthYear: false,
      visibleStartDate: false,
      visibleStartHour: false,
      visibleEndDate: false,
    }
  if (codeIdxType === '4')
    return {
      visibleMonthYearEnd: false,
      visibleCustomDateSelection: false,
    }
  else return {}
}

const getMonthType = codeIdxType => {
  if (codeIdxType === '0')
    return {
      visibleMonthYear: true,
      visibleStartDate: false,
      visibleStartHour: false,
      visibleMonthYearEnd: true,
      visibleEndDate: false,
      visibleEndHour: false,
    }
  if (codeIdxType === '2')
    return {
      visibleMonthYear: false,
      visibleStartDate: false,
      visibleStartHour: false,
      visibleMonthYearEnd: false,
      visibleEndDate: false,
      visibleEndHour: false,
      visibleCustomDateSelection: false,
    }
  if (codeIdxType === '3')
    return {
      visibleMonthYear: true,
      visibleStartDate: false,
      visibleStartHour: false,
      visibleMonthYearEnd: false,
      visibleEndDate: false,
      visibleEndHour: false,
      visibleCustomDateSelection: false,
    }
  if (codeIdxType === '4')
    return {
      visibleStartDate: false,
      visibleEndDate: false,
      visibleStartYear: true,
      visibleEndYear: true,
    }
  if (codeIdxType === '5')
    return {
      visibleStartDate: false,
      visibleEndDate: false,
      visibleStartYear: true,
      visibleEndYear: false,
    }
  if (codeIdxType === '6')
    return {
      visibleMonthYear: true,
      visibleStartDate: false,
      visibleStartHour: false,
      visibleMonthYearEnd: false,
      visibleEndDate: false,
      visibleEndHour: false,
      visibleCustomDateSelection: false,
      visibleStartDateLabel: 'As Of :',
    }
  else return {}
}

const getDateType = codeIdxType => {
  if (codeIdxType === '0') return { visibleStartDate: true }
  if (codeIdxType === '1' || codeIdxType === '2')
    return { visibleStartDate: true, visibleEndDate: true }
  else return { visibleCustomDateSelection: false }
}

const getViewType = codeIdxType => {
  if (codeIdxType === '0')
    return { visibleUnit: true, choiceUnitStation: 'unit' }
  else if (codeIdxType === '1')
    return { visibleUnit: true, visibleStation: true }
  else if (codeIdxType === '2')
    return {
      visibleStation: true,
      visibleUnit: false,
      choiceUnitStation: 'station',
    }
  else return { visibleUnit: false, visibleStation: false }
}

const getRegionRiverStationcodeSelection = codeIdxType => {
  if (codeIdxType === '1')
    return { visibleRegionriverStationcodeSelection: true }
  else return { visibleRegionriverStationcodeSelection: false }
}
